<template>
  <!-- <div class="check-frequencia" tabindex="0" @keyup.space="handleSpace" > -->
    <label class="check-frequencia "   :title="dadosCheck('titulo')" >
      <input  type="checkbox" :disabled="disabled" @click="retornaValor"
        :aria-label="(value=== 'P') ? 'Presente': 
                     (value=== 'A')?  'Presente ':
                     (value === 'S') ? '':''
        "
       />
      <div class="check-frequencia-bloco" >
        <transition
          name="check-frequencia-anim"
          enter-active-class="animated fadeIn"
        >
          <v-icon v-if="remoto !== 'S'" size="27" :color="dadosCheck('cor')">{{
            dadosCheck("icone")
          }}</v-icon>
          <v-icon
            v-if="remoto === 'S'"
            size="27"
            :color="dadosCheck('cor')"
            style="font-weight: bold; font-family: Arial"
            >{{ "R" }}</v-icon
          >
          <v-icon
            v-if="remoto === ''"
            size="27"
            :color="dadosCheck('cor')"
            style="font-weight: bold; font-family: Arial"
            >{{ dadosCheck("icone") }}</v-icon
          >
        </transition>
      </div>
    </label>
  <!-- </div> -->
</template>

<script>
export default {
  name: "CheckFrequencia",
  props: {
    value: [String, Number, Object],
    atestado: [String],
    remoto: [String],
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    check: {
      titulo: ["Atestado", "Presente", "Ausente", "Remoto", "Presencial"],
      cor: ["gray", "green", "red", "green", "red"],
      icone: ["healing", "check", "block", "local_parking", "local_parking"],
    },
  }),
  methods: {
    teste(el) {

      alert(el)
    },
    // handleSpace(event) {
    //   if (event.target.tagName === "LABEL") {
    //     event.preventDefault();
    //     event.target.querySelector("input[type='checkbox']").click();
    //   }
    // },
    dadosCheck(posicao) {
      if (this.atestado === "S") {
        return this.check[posicao][0];
      }
      if (this.remoto !== undefined) {
        if (this.remoto === "S") {
          return this.check[posicao][3];
        } else {
          if (this.remoto === "N") {
            return this.check[posicao][4];
          }
        }

        switch (this.value) {
          case "S":
            return this.check[posicao][3];
          case "N":
            return this.check[posicao][4];
        }
      } else {
        switch (this.value) {
          case "P":
            return this.check[posicao][1];
          case "A":
            return this.check[posicao][2];
        }
      }
    },
    retornaValor() {
      let valor = "";

      if (this.remoto !== undefined) {
        if (this.remoto === null) {
          valor = "N";
        } else {
          valor = this.value === "S" ? "N" : "S";
        }
      } else if (this.disabled) {
        valor = null;
      } else if (this.atestado === "S") {
        valor = "A";
      } else {
        valor = this.value === "P" ? "A" : "P";
      }
      this.$emit("input", valor);
      this.$emit("click");
    },
  },
};
</script>

<style lang="scss">
.check-frequencia {
  display: inline-block;

  label {
    width: 24px;
    height: 24px;
    cursor: pointer;
  }

  input {
    width: 0;
    height: 0;
    /* visibility: hidden; */

    &:disabled {
      & ~ .check-frequencia-bloco {
        background-color: #94949424;
        cursor: default;

        &:hover {
          box-shadow: 0px 0px 2px 1px #858585;
        }
      }
    }
  }
  .check-frequencia-bloco {
    width: 26px;
    height: 26px;
    //border: 2px solid black;
    border-radius: 4px;
    background-color: #f5f5f5;
    cursor: pointer;
    text-align: center;
    box-shadow: 0px 0px 2px 1px #858585;
    margin-top: -19px;

    .v-icon {
      //margin-left: 1px;
      //margin-top: 1px;
    }

    &:hover {
      box-shadow: 0px 0px 6px 2px #2b69e4;
    }
  }
}
</style>
